export default "__VITE_ASSET__4c6357c3__"